/*
This file was created by the script build.py 
*/

import {buttonOnClick, checkAllButtons, callAllCategories} from "./globalFilterUI"
import {allCheckboxesState} from "./checkboxState"

// show or hide buttons
$(document).ready(function(){
    $("#iconFurtherCategorisationHeavyIon").click(function(){
        var buttons = document.getElementById("buttonWrapperFurtherCategorisationHeavyIon")
        const iconId = "#"+$(this).attr('id');
        if(buttons.classList.contains("show")){
            $(buttons).hide()
            buttons.classList.remove("show")
            $(iconId).toggleClass("bi bi-caret-up-fill", false)
            $(iconId).toggleClass("bi bi-caret-down-fill", true)
        }
        else{
            $(buttons).show()
            buttons.classList.add("show")
            $(iconId).toggleClass("bi bi-caret-down-fill", false)
            $(iconId).toggleClass("bi bi-caret-up-fill", true)
        }
    })
})

//checkbox Further Categorisation Heavy Ion
document.getElementById("categoryFurtherCategorisationHeavyIon").onclick=function(){
    const checkboxId = $(this).attr('id')
    var checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    if(allCheckboxesState[checkboxId].checked){
        checkbox.checked = true
    }
    else if(allCheckboxesState[checkboxId].indeterminate){
        checkbox.indeterminate = true
    }
    else{
        checkbox.checked = false
    }
    
    const iconId = "#iconFurtherCategorisationHeavyIon";
    var buttons = document.getElementById("buttonWrapperFurtherCategorisationHeavyIon")
    if(buttons.classList.contains("show")){
        $(buttons).hide()
        buttons.classList.remove("show")
        $(iconId).toggleClass("bi bi-caret-up-fill", false)
        $(iconId).toggleClass("bi bi-caret-down-fill", true)
    }
    else{
        $(buttons).show()
        buttons.classList.add("show")
        $(iconId).toggleClass("bi bi-caret-down-fill", false)
        $(iconId).toggleClass("bi bi-caret-up-fill", true)
    }
    allCheckboxesState[checkboxId].checked = checkbox.checked

}

//Name Further Categorisation Heavy Ion
document.getElementById("furtherCategorisationHeavyIonLabel").onclick=function(){
    const iconId = "#iconFurtherCategorisationHeavyIon";
    var buttons = document.getElementById("buttonWrapperFurtherCategorisationHeavyIon")
    if(buttons.classList.contains("show")){
        $(buttons).hide()
        buttons.classList.remove("show")
        $(iconId).toggleClass("bi bi-caret-up-fill", false)
        $(iconId).toggleClass("bi bi-caret-down-fill", true)
    }
    else{
        $(buttons).show()
        buttons.classList.add("show")
        $(iconId).toggleClass("bi bi-caret-down-fill", false)
        $(iconId).toggleClass("bi bi-caret-up-fill", true)
    }
    
}

//Button: "select all buttons"
document.getElementById("buttonFurtherCategorisationHeavyIonSelectAll").onclick=function(){
    const checkboxId = "categoryFurtherCategorisationHeavyIon"
    var checkbox = document.getElementById(checkboxId)
    checkbox.indeterminate = false
    checkbox.checked = true
    allCheckboxesState[checkboxId].checked = checkbox.checked
    checkAllButtons({
        "checkboxId" : checkboxId
    })

    callAllCategories()
}

//Button: "select none buttons"
document.getElementById("buttonFurtherCategorisationHeavyIonSelectNone").onclick=function(){
    const checkboxId = "categoryFurtherCategorisationHeavyIon"
    var checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    checkbox.indeterminate = false
    allCheckboxesState[checkboxId].checked = checkbox.checked
    allCheckboxesState[checkboxId].indeterminate = checkbox.indeterminate
    checkAllButtons({
        "checkboxId" : checkboxId
    })

    callAllCategories()
}

// any-Button Further Categorisation Heavy Ion
document.getElementById("buttonFurtherCategorisationHeavyIonAny").onclick = function(){
    var buttonAny = document.getElementById("buttonFurtherCategorisationHeavyIonAny")
    var buttonAll = document.getElementById("buttonFurtherCategorisationHeavyIonAll")
    buttonAny.classList.add("chosen","text-light","no-click");
    buttonAll.classList.remove("chosen","text-light","no-click")
    callAllCategories()
}

// all-Button Further Categorisation Heavy Ion
document.getElementById("buttonFurtherCategorisationHeavyIonAll").onclick = function(){
    var buttonAny = document.getElementById("buttonFurtherCategorisationHeavyIonAny")
    var buttonAll = document.getElementById("buttonFurtherCategorisationHeavyIonAll")
    buttonAll.classList.add("chosen","text-light","no-click");
    buttonAny.classList.remove("chosen","text-light","no-click")
    callAllCategories()
}


//Button EllipticFlowandeventproperties in Further Categorisation Heavy Ion change color on click Event
document.getElementById("buttonFurtherCategorisationHeavyIonEllipticFlowandeventproperties").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Forwardphysics in Further Categorisation Heavy Ion change color on click Event
document.getElementById("buttonFurtherCategorisationHeavyIonForwardphysics").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Initialstage in Further Categorisation Heavy Ion change color on click Event
document.getElementById("buttonFurtherCategorisationHeavyIonInitialstage").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Jetproperties in Further Categorisation Heavy Ion change color on click Event
document.getElementById("buttonFurtherCategorisationHeavyIonJetproperties").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button OpenHeavyflavor in Further Categorisation Heavy Ion change color on click Event
document.getElementById("buttonFurtherCategorisationHeavyIonOpenHeavyflavor").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Particledistributionsandcorrelations in Further Categorisation Heavy Ion change color on click Event
document.getElementById("buttonFurtherCategorisationHeavyIonParticledistributionsandcorrelations").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Quarkonia in Further Categorisation Heavy Ion change color on click Event
document.getElementById("buttonFurtherCategorisationHeavyIonQuarkonia").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button UltraPeripheralcollisions in Further Categorisation Heavy Ion change color on click Event
document.getElementById("buttonFurtherCategorisationHeavyIonUltraPeripheralcollisions").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

